import Util from '../script/util';
import { message, Modal } from 'antd';
import HTTP from '../script/service';
import store from '../store/store';

const ARTC = (window,
function () {
  const that = {
    token: null,
    client: null,
    joined: false,
    published: false,
    localStream: null,
    remoteStreams: [],
    params: {},
    device_list: [],
    mic_list: [],
    liveConfig: {},
    audioVolume: 100, //伴奏音量
    playVolume: 100,
    disAudio: false, //是否静音
  };
  //初始化
  that.openConn = function (room) {
    that.room = room;
    that.liveConfig = room.liveConfig || {};
    if (!that.client) {
      initClient(function () {
        bindEvent();
        joinChannel();
        that.room.events['RTC_INIT_END'] &&
          that.room.events['RTC_INIT_END'](that);
      });
    } else {
      joinChannel();
      that.room.events['RTC_INIT_END'] &&
        that.room.events['RTC_INIT_END'](that);
    }

    store.dispatch({type: "RTC_LOAD_COMPLETE", data: {rtcLoadComplete: true}});
    return that;
  };
  //实例化客户端
  function initClient(callback) {
    that.remoteStreams = [];
    that.default_mic = null;
    that.default_div = null;
    that.audio_state = false; //伴奏状态
    that.dev_state = true; //扬声器状态
    that.mic_state = true; //麦克风状态
    that.disAudio = false; //是否静音
    that.wifiDown = document.getElementById('wifi-down');
    that.wifiUp = document.getElementById('wifi-up');
    that.client = window.AgoraRTC.createClient({ mode: 'live', codec: 'h264' });
    const { rootConfig } = store.getState();
    //初始化
    that.client.init(rootConfig.agoraAppID, function () {
      getDevices().then(callback);
    });
  }
  //获取设备
  function getDevices(upMic) {
    return new Promise((resolve, reject) => {
      window.AgoraRTC.getDevices(function (devices) {
        that.mic_list = devices.filter((device) => device.kind == 'audioinput');
        that.device_list = devices.filter(
          (device) => device.kind == 'audiooutput'
        );
        setDefaultDevices(upMic);
        resolve();
      });
    });
  }
  //设置默认设备
  function setDefaultDevices(upMic) {
    that.audioVolume = 100;
    that.playVolume = 100;
    //伴奏音量
    let audioVolume = Util.readCookie('audioVolume');
    if (audioVolume && !isNaN(audioVolume)) {
      that.audioVolume = parseInt(audioVolume);
    }
    //扬声器音量
    let playVolume = Util.readCookie('playVolume');
    if (playVolume && !isNaN(playVolume)) {
      that.playVolume = parseInt(playVolume);
    }

    if (that.device_list.length < 1) {
      that.device_list = [
        {
          deviceId: 'default',
          groupId: '',
          kind: 'audioinput',
          label: '默认 - 线路',
        },
      ];
    }
    if (upMic && that.mic_list.length < 1) {
      message.error('麦克风设备检测异常：请确麦克风/声卡设备连接正常后重试~');
      return;
    }
    //设置默认设备
    let def_d = Util.readCookie('default_div');
    if (def_d) {
      that.default_div = JSON.parse(def_d);
    } else {
      that.default_div = that.device_list[0];
    }
    let def_m = Util.readCookie('default_mic');
    if (def_m) {
      that.default_mic = JSON.parse(def_m);
    } else {
      that.default_mic = that.mic_list[0];
    }
  }
  //加入频道
  function joinChannel() {
    //先给自己设定 观众 角色
    that.client.setClientRole('audience');
    //每次加入默认解开
    that.room.events['CHANGE_DEV_STATE'] &&
      that.room.events['CHANGE_DEV_STATE'](false);
    HTTP._get_agora_token({
      uid: that.room.uid || 0,
      channelName: that.room.roomid,
    }).then(async (res) => {
      if (res?.code === 200) {
        const data = res.data;
        that.token = data.token;
        that.client.join(
          that.token,
          that.room.roomid,
          that.room.uid,
          function (uid) {
            that.params.uid = uid;
            that.joined = true;

            that.room.events['CHANGE_DEV_STATE'] &&
              that.room.events['CHANGE_DEV_STATE'](!that.dev_state); // 切换房间，扬声器状态保持
          }
        );
      } else {
        message.warning(res.message);
      }
    });
  }
  //音频流事件监听
  function bindEvent() {
    //回调通知 App 远端音视频流已添加
    that.client.on('stream-added', function (evt) {
      var remoteStream = evt.stream;
      var id = remoteStream.getId();
      if (id !== that.params.uid) {
        //加入订阅
        that.client.subscribe(remoteStream);
      }
    });
    //回调通知 App 已接收远端音视频流。
    that.client.on('stream-subscribed', function (evt) {
      var remoteStream = evt.stream;
      var id = remoteStream.getId();
      //先删除
      that.removeLocalStream(id);
      //再加入
      addReview('remote_stream_' + id);
      setTimeout(() => {
        remoteStream.setAudioVolume(that.dev_state ? that.playVolume : 0);
        //开始自动播放
        remoteStream.play('remote_stream_' + id, function (err) {
          if (err && err.status !== 'aborted' && !err.message) {
            // 播放失败，一般为浏览器策略阻止。引导用户用手势触发恢复播放
            document.body.addEventListener('mousedown', rePlayStreams);
            that.room.events['LIVE_PLAY_ERROR'] &&
              that.room.events['LIVE_PLAY_ERROR']();
          }
        });
        that.remoteStreams.push(remoteStream);
      }, 200);
    });
    //回调通知 App 已删除远端音视频流
    that.client.on('stream-removed', function (evt) {
      var remoteStream = evt.stream;
      that.removeLocalStream(remoteStream.getId(), remoteStream);
    });
    that.client.enableAudioVolumeIndicator();
    //回调提示频道内正在说话的远端用户及其音量。
    that.client.on('volume-indicator', function (evt) {
      let speakMembers = [];
      const members = evt?.attr || [];
      // 获取自己的音浪
      if (that.localStream && that.published) {
        let volume_me = parseInt(that.localStream.getAudioLevel() * 100);
        if (volume_me > 0) {
          members.push({
            uid: that.params.uid,
            level: volume_me,
          });
        }
      }
      members.forEach(item => {
        let isSpeak = false;

        if (item.level > 10) {
          isSpeak = true;
        }

        speakMembers.push({uid: item.uid, roomid: that.room.roomid, isSpeak});
      })
      that.room.showSpeakUsers(speakMembers);
    });
    //回调报告本地用户的上下行网络质量。
    that.client.on('network-quality', function (stats) {
      if (that.wifiDown)
        that.wifiDown.className = 'w-down d-' + stats.downlinkNetworkQuality;
      if (that.wifiUp)
        that.wifiUp.className = 'w-up d-' + stats.uplinkNetworkQuality;
    });
    //回调通知 app 有错误信息
    that.client.on('error', function (err) {
      console.error('reconnect', err);
      if (err.reason != 'SOCKET_DISCONNECTED') {
        Modal.confirm({
          title: '系统提示',
          icon: null,
          closable: true,
          content:
            '服务器的连接因为网络原因断开了，重新连接失败，请退出房间重试。',
          className: 'daidai-confirm-style',
          cancelText: '取消',
          okText: '确定',
          centered: true,
          onOk() {
            window.location.reload();
          },
          onCancel() {
            window.location.reload();
          },
        });
      }
    });
    //回调通知正在与服务器重新建立连接
    that.client.on('reconnect', function (obj) {
      console.warn('reconnect', obj);
    });
    //回调通知 App SDK 与服务器的连接状态发生改变
    that.client.on('connection-state-change', function (evt) {
      if (evt.curState == 'CONNECTED') {
        if (!that.room.conn) {
          that.destroyRoom(3);
        } else {
          that.delToMic(2);
        }
      }
    });
    //在 Token 过期后，会收到该事件通知
    that.client.on('onTokenPrivilegeDidExpire', function () {
      Modal.confirm({
        title: '系统提示',
        icon: null,
        closable: true,
        content: '你的token权限失效，请退出房间重现进入。',
        className: 'daidai-confirm-style',
        cancelText: '取消',
        okText: '确定',
        centered: true,
        onOk() {
          window.location.reload();
        },
        onCancel() {
          window.location.reload();
        },
      });
    });
  }
  //重新播放所有音频流
  function rePlayStreams() {
    that.remoteStreams.forEach((item) => {
      item.resume();
    });
    //移除事件
    document.body.removeEventListener('mousedown', rePlayStreams);
  }
  //创建通话
  function addReview(id) {
    if (!document.getElementById(id)) {
      let element = document.createElement('div');
      element.id = id;
      document.getElementById('local_video').appendChild(element);
    }
  }
  //移除通话
  function deleteReview(id) {
    let element = document.getElementById(id);
    if (element) {
      const dom = document.getElementById('local_video');
      dom?.removeChild && dom.removeChild(element);
    }
  }
  //创建本地流
  function createLocalStream(callback) {
    //先关闭本地流
    if (that.localStream) {
      //如果伴奏还在播放提示
      if (that.localStream.audioMixing && that.localStream.audioMixing.ctx) {
        message.warning('麦克风被切换，伴奏播放被中断。需要手动重新开启。');
      }
      //1. 取消发布
      that.changeRoleToAudience();
      //2. 关闭本地流
      that.localStream.stop();
      that.localStream.close();
      that.localStream = null;
      that.playMusic = null;
      //如果原来的伴奏还是开启状态
      that.room.events['CHANGE_AUDIO_STATE'] &&
        that.room.events['CHANGE_AUDIO_STATE'](1, that.audioVolume);
    }
    //1. 创建
    that.localStream = window.AgoraRTC.createStream({
      streamID: that.params.uid,
      audio: true,
      microphoneId: that.default_mic.deviceId,
      video: false,
      screen: false,
    });
    //音质设置 统一使用高音质
    that.localStream.setAudioProfile('high_quality_stereo');
    // that.localStream.setAudioProfile('music_standard');
    //2. 初始
    that.localStream.init(
      function () {
        that.localStream.play('local_stream');
        that.setAudioVolume(that.audioVolume);
        callback && callback();
      },
      function (err) {
        if (err.msg == 'NotAllowedError') {
          message.error('操作失败：你拒绝授予对应的摄像头或麦克风权限。');
        } else if (err.msg == 'DEVICES_NOT_FOUND') {
          message.error(
            '麦克风设备检测异常：请确麦克风/声卡设备连接正常后重试~'
          );
        } else if (err.msg == 'NOT_SUPPORTED') {
          message.error('浏览器不支持获取获取麦克风权限');
        } else if (err.msg == 'PERMISSION_DENIED') {
          message.error('浏览器禁用设备或者用户拒绝打开设备');
        } else {
          message.error(
            '你的设备/浏览器无法支持使用，推荐使用最新的Chrome浏览器/下载PC客户端。'
          );
        }
      }
    );
  }
  //更新直播队列
  function getLiveConfig(callback) {
    //直播上报
    HTTP._mixed_channel_create({
      uid: that.room.uid,
      roomid: that.room.roomid,
      roomcid: that.room.roomid,
      creator: that.room.account,
    });
    const { rootConfig } = store.getState();
    //如果直播已经存在
    if (that.room.hasLive()) {
      that.liveConfig = {
        channelName: that.room.roomid, //房间名称
        channelId: null, //通话渠道 由网易返回
        creator: that.room.account, //直播创建者
        cid: null, //通话cid标识 由接口返回
        pushUrl: null, //推流地址
        rtmpPullUrl: null, //拉流地址
        web_version: rootConfig.version, //网页独有版本参数
        pc_version: that.room.base.clientInfo.version, //pc独有版本参数
        master_type: that.room.base.client, //主播当前终端类型
        config: [...that.room.liveConfig.config], //麦位属性配置
      };
    } else {
      that.liveConfig = {
        channelName: that.room.roomid, //房间名称
        channelId: null, //通话渠道 由网易返回
        creator: that.room.account, //直播创建者
        cid: null, //通话cid标识 由接口返回
        pushUrl: null, //推流地址
        rtmpPullUrl: null, //拉流地址
        web_version: rootConfig.version, //网页独有版本参数
        pc_version: that.room.base.clientInfo.version, //pc独有版本参数
        master_type: that.room.base.client, //主播当前终端类型
        config: [], //麦位属性配置
      };
      for (let i = 0; i < 9; i++) {
        that.liveConfig.config.push({
          index: i, //麦位
          type: i == 0 ? 0 : 1, //类型  0 主播位置 1 互动位  2 老板位
          enabled: true, // 是否启用用位置
          microphone: true, // 是否启用麦克风
          disAudio: false, //是否静音
        });
      }
    }
    //2、发送麦位配置
    that.room.modifyConfig(that.liveConfig, false, function () {
      //3、发送1-1指令
      that.room.sendCustomMsg({
        action: '1-1',
        creator: that.room.account,
      });
      callback && callback();
    });
  }
  //开始播放新的伴奏
  function startAudioMixing(callback) {
    that.localStream.startAudioMixing(
      {
        replace: false, //是否要用音频文件替换本地音频流
        playTime: 0, //播放时间位置 整数，取值范围为 [0,100000000]
        loop: false, //循环次数
        cacheResource: true, //是否缓存混音文件
        filePath: that.playMusic.url,
      },
      function (error) {
        if (error) {
          message.error(
            '音乐播放异常，该首歌曲可能已损坏，请在系统中删除后重新上传。'
          );
          that.playMusic = null;
          callback && callback(2, error);
          return;
        }
        if (that.localStream) {
          that.playMusic.playing = true;
          callback && callback(2);
          //获取一次时长
          let timeLength = that.localStream.getAudioMixingDuration();
          let timeParam = Util.formatDuring(timeLength);
          let dom = document.getElementById('music-all-time');
          if (dom) {
            dom.innerHTML = timeParam.minutes + ':' + timeParam.seconds;
          }
          //获取播放时长
          timeoutGetPlayTime();
        }
      }
    );
  }
  //定时获取 播放时间
  function timeoutGetPlayTime() {
    clearTimeout(that.timePlayEvel);
    if (!that.localStream) return;
    if (!that.playMusic) return;
    if (!that.playMusic.play) return;
    if (!that.localStream.audioMixing) return;
    if (!that.localStream.audioMixing.ctx) return;
    if (!that.localStream.getAudioMixingCurrentPosition) {
      that.timePlayEvel = setTimeout(timeoutGetPlayTime, 1000);
      return;
    }
    let timeLength = that.localStream.getAudioMixingCurrentPosition();
    let timeParam = Util.formatDuring(timeLength);
    let dom = document.getElementById('music-play-time');
    if (dom) {
      dom.innerHTML = timeParam.minutes + ':' + timeParam.seconds;
    }
    that.timePlayEvel = setTimeout(timeoutGetPlayTime, 1000);
  }
  //伴奏监听
  function audioMixingPlayed() {
    if (!that.localStream) return;
    if (!that.localStream.audioMixing) return;
    if (that.localStream.audioMixing.ctx) return;
    //播放结束
    that.localStream.on('audioMixingFinished', function (evt) {
      clearTimeout(that.timePlayEvel);
      if (that.localStream) {
        that.playMusic.play = false;
        that.room.events['CHANGE_AUDIO_STATE'] &&
          that.room.events['CHANGE_AUDIO_STATE'](1, that.audioVolume);
        that.room.events['CHANGE_AUDIO_NEXT'] &&
          that.room.events['CHANGE_AUDIO_NEXT']();
      }
    });
  }
  //验证是否符合开启标准
  function viliDataAutioText() {
    if (!that.audioContext) {
      that.audioContext = new (window.AudioContext ||
        window.webkitAudioContext)();
    }
    if (!that.audioContext) {
      message.error(
        '你的浏览器不支持伴奏功能，请使用最新版本Chrome浏览器/下载客户端'
      );
      return false;
    }
    let version = parseInt(getBrowser('v'));
    let name = getBrowser('n');
    //81内核之前，不允许使用大于48000的采样率
    if (name != 'chrome') return true;
    if (version >= 81) return true;
    if (that.audioContext.sampleRate <= 48000) return true;
    return false;
  }
  //获取浏览器版本
  function getBrowser(n) {
    /* eslint-disable */
    var ua = window.navigator.userAgent.toLowerCase();
    var s = null;
    var name = '';
    var ver = 0;
    //探测浏览器
    (s = ua.match(/msie ([\d.]+)/))
      ? _set('ie', _toFixedVersion(s[1]))
      : (s = ua.match(/firefox\/([\d.]+)/))
        ? _set('firefox', _toFixedVersion(s[1]))
        : (s = ua.match(/chrome\/([\d.]+)/))
          ? _set('chrome', _toFixedVersion(s[1]))
          : (s = ua.match(/opera.([\d.]+)/))
            ? _set('opera', _toFixedVersion(s[1]))
            : (s = ua.match(/version\/([\d.]+).*safari/))
              ? _set('safari', _toFixedVersion(s[1]))
              : 0;
    function _toFixedVersion(ver, floatLength) {
      ver = ('' + ver).replace(/_/g, '.');
      floatLength = floatLength || 1;
      ver = String(ver).split('.');
      ver = ver[0] + '.' + (ver[1] || '0');
      ver = Number(ver).toFixed(floatLength);
      return ver;
    }
    function _set(bname, bver) {
      name = bname;
      ver = bver;
    }
    /* eslint-enable*/
    return n == 'n' ? name : n == 'v' ? ver : name + ver;
  }
  //加入成功
  function joinSuccess(callback) {
    that.published = true;
    that.room.queuePoll(`queue_${that.room.uid}`);
    //如果当前在相亲模式-并且游戏进行中, 用户需要上报
    if (
      that.room.roomInfo &&
      that.room.roomInfo.custom &&
      that.room.roomInfo.custom.rmode == 1 &&
      that.room.datingData &&
      that.room.datingData.sdata
    ) {
      HTTP._addDataingUser({
        roomid: that.room.roomid,
        uids: that.room.uid,
      });
    }
    //派单房, 用户需要上报 todo 2.21.3 更改为所有房间都上报
    // if (that.room.roomInfo && that.room.roomInfo.custom && that.room.roomInfo.custom.rmode == 6 && that.room.sendOrders && that.room.sendOrders.msgId) {
    if (that.room.base.microType === 0) {
      if (that.room.roomInfo && that.room.roomInfo.custom) {
        let meque = that.room.queueObject[that.room.account];
        let msgId = null;
        if (
          that.room.roomInfo.custom.rmode == 6 &&
          that.room.sendOrders &&
          that.room.sendOrders.msgId
        ) {
          msgId = that.room.sendOrders.msgId;
        }
        if (meque) {
          HTTP._oneorder_upMicrophone({
            uid: that.room.uid,
            roomId: that.room.roomid,
            index: meque.index,
            msgId,
          });
        }
      }
    }

    callback && callback();
  }
  //设置伴奏音量
  that.setAudioVolume = function (volume, mute) {
    if (!that.localStream) return false;
    if (mute) {
      that.localStream.adjustAudioMixingVolume(0);
      return true;
    }
    if (volume < 0) volume = 0;
    if (volume > 100) volume = 100;
    that.localStream.adjustAudioMixingVolume(volume);
    Util.setCookie('audioVolume', volume);
    that.audioVolume = volume;
    return true;
  };
  //设置扬声器音量
  that.setPlayVolume = function (volume, callback = null) {
    if (that.isGameing && that.isGameOperateSpeaker) {
      message.warning('游戏中无法调节扬声器音量');
      callback && callback(false);
      return;
    }
    that.dev_state = true;
    Util.setCookie('playVolume', volume);
    that.playVolume = volume;
    that.remoteStreams.forEach((remoteStream) => {
      remoteStream.setAudioVolume(that.playVolume);
    });
    callback && callback(true);
  };
  //删除音频流
  that.removeLocalStream = function (id, remoteStream) {
    var uid = 'remote_stream_' + id;
    if (remoteStream) {
      remoteStream.isPlaying() && remoteStream.stop(uid);
      deleteReview(uid);
    } else {
      deleteReview(uid);
    }
    that.remoteStreams = that.remoteStreams.filter((stream) => {
      return stream.getId() !== id;
    });
  };
  //开启本地扬声器设备
  that.changeVoiceState = function ({
    open,
    dev = null,
    operateSource = false,
  }) {
    if (!that.client) {
      return false;
    }
    if (that.isGameing && that.isGameOperateSpeaker && !operateSource && open) {
      message.warning('游戏中不允许切换扬声器状态');
      return;
    }
    that.isGameOperateSpeaker = operateSource;
    that.dev_state = open;
    //改变扬声器图标
    if (that.dev_state) {
      that.room.events['CHANGE_DEV_STATE'] &&
        that.room.events['CHANGE_DEV_STATE'](false);
    } else {
      that.room.events['CHANGE_DEV_STATE'] &&
        that.room.events['CHANGE_DEV_STATE'](true);
    }
    //存储 cookie
    if (dev) {
      let oldId = that.default_div ? that.default_div.deviceId : null;
      that.default_div = dev;
      Util.setCookie('default_div', JSON.stringify(that.default_div));
      if (that.localStream && oldId != that.default_div.deviceId) {
        that.localStream.setAudioOutput(
          that.default_div.deviceId,
          function () {
            that.room.events['CHANGE_DEV_SELECT'] &&
              that.room.events['CHANGE_DEV_SELECT'](that.playVolume);
          },
          function (error) {
            message.error('切换扬声器失败，请重试: ', error);
          }
        );
      }
    }
    if (that.dev_state) {
      that.remoteStreams.forEach((item) => {
        item.setAudioVolume(that.playVolume);
      });
    } else {
      that.remoteStreams.forEach((item) => {
        item.setAudioVolume(0);
      });
    }
  };
  //开启本地麦克风设备
  that.changeMicState = function ({
    open,
    mic = null,
    operateSource = false,
    callback = null,
  }) {
    if (!that.client) {
      return false;
    }
    if (that.isGameing && that.isGameOperateMic && !operateSource && open) {
      message.warning('游戏中不允许切换麦克风状态');
      return false;
    }
    that.isGameOperateMic = operateSource;
    that.mic_state = open;

    if (that.localStream) {
      //改变麦克风图标
      let dom = document.querySelector('.icon-ac-mic');
      if (dom) {
        if (that.mic_state) {
          dom.className = 'icon-ac-mic';
        } else {
          dom.className = 'icon-ac-mic dis';
        }
      }

      if (that.mic_state) {
        that.localStream.unmuteAudio();
      } else {
        that.localStream.muteAudio();
      }
    }
    callback && callback();
  };
  //开始伴奏
  that.changeAudioState = function (open, playMusic, callback) {
    if (!that.localStream) return;
    if (that.playMusic && that.playMusic.playing == false) return;
    that.audio_state = open;
    if (that.audio_state) {
      let bool = viliDataAutioText();
      if (bool) {
        //绑定状态监听
        audioMixingPlayed();
        //恢复播放
        if (
          that.playMusic &&
          playMusic.url == that.playMusic.url &&
          that.playMusic.play
        ) {
          that.localStream.resumeAudioMixing();
          callback && callback(2);
          let timeLength = that.localStream.getAudioMixingDuration();
          let timeParam = Util.formatDuring(timeLength);
          let dom = document.getElementById('music-all-time');
          if (dom) {
            dom.innerHTML = timeParam.minutes + ':' + timeParam.seconds;
          }
          //获取播放时长
          timeoutGetPlayTime();
          return;
        }
        //如果正在播放 - 先停止
        if (
          that.localStream.audioMixing &&
          that.localStream.audioMixing.ctx &&
          that.playMusic &&
          that.playMusic.play
        ) {
          clearTimeout(that.timePlayEvel);
          that.localStream.stopAudioMixing(function () {
            that.playMusic = { ...playMusic, play: true, playing: false };
            startAudioMixing(callback);
          });
          return;
        }
        //直接新建播放
        that.playMusic = { ...playMusic, play: true, playing: false };
        startAudioMixing(callback);
      } else {
        message.error(
          '你的电脑无法支持高频采样率，请在电脑右下角点击：声音 > 属性 > 扬声器 > 属性 > 高级 > 中设置为48000Hz'
        );
      }
    } else {
      clearTimeout(that.timePlayEvel);
      //暂停
      that.localStream.pauseAudioMixing(function (error) {
        if (error) message.error('伴奏停止异常：' + error);
        callback && callback(1);
      });
    }
  };
  //上麦
  that.publishLocalStream = function (queue) {
    if (that.slefStream) return;
    return new Promise((resolve, reject) => {
      that.index = queue.index;
      if (that.mic_list.length == 0) {
        that.room.closeLoading && that.room.closeLoading();
        message.error(
          '未检出到你的电脑上有麦克风设备，请检查正确安装/打开后再试。'
        );
        return;
      }
      that.slefStream = true;
      //1. 创建自己的音频流
      createLocalStream(function () {
        //2. 获取设备
        getDevices(true).then(function () {
          if (that.index == 0) {
            //更新直播队列
            getLiveConfig(function () {
              //3. 发布
              that.changeRoleToPlayer();
              //4. 上报
              joinSuccess(function () {
                resolve();
              });
            });
          } else {
            //3. 发布
            that.changeRoleToPlayer();
            //4. 创建自己的队列
            joinSuccess(function () {
              resolve();
            });
          }
          // 5. 设置一次本地设备
          //初始化设置一次扬声器
          that.changeVoiceState({ open: true, dev: that.default_div });
          // 设置麦克风状态
          that.changeMicState({ open: that.mic_state });

          // 显示麦克风
          that.room.events['CHANGE_MIC_STATE'] &&
            that.room.events['CHANGE_MIC_STATE']('block', that.playVolume);
          //显示伴奏状态
          that.room.events['CHANGE_AUDIO_STATE'] &&
            that.room.events['CHANGE_AUDIO_STATE'](true, that.audioVolume);
        });
      });
    });
  };
  //踢TA下麦 - 我自己下麦
  that.delToMic = function (n) {
    //麦克风状态回调
    that.room.events['CHANGE_MIC_STATE'] &&
      that.room.events['CHANGE_MIC_STATE']('none', that.playVolume);
    //关闭伴奏状态
    that.room.events['CHANGE_AUDIO_STATE'] &&
      that.room.events['CHANGE_AUDIO_STATE'](false);
    that.mic_state = true; //麦克风状态
    //关闭存在本地流
    if (that.localStream) {
      //1. 取消发布
      that.changeRoleToAudience();
      //2. 关闭本地流
      that.localStream.stop();
      that.localStream.close();
    }
    that.localStream = null;
    that.playMusic = null;
    that.slefStream = false;
    //删除自己的队列
    if (that.room.hasQueume()) {
      const { microType } = store.getState();
      if (microType === 0) {
        that.room.queuePoll(that.room.account);
      } else {
        HTTP._post_server_down_microphone({
          roomId: that.room.roomid,
          operationType: 0,
        });
      }
    }

    that.room.events['CHANGE_MIC_GAME_OVER'] &&
      that.room.events['CHANGE_MIC_GAME_OVER'](n);
  };
  //发言
  that.changeRoleToPlayer = function () {
    that.localStream && that.client.publish(that.localStream);
    that.published = true;
    that.disAudio = false;
  };
  //闭麦
  that.changeRoleToAudience = function () {
    that.localStream && that.client.unpublish(that.localStream);
    that.published = false;
    that.disAudio = true;
  };
  //销毁离开房间
  that.destroyRoom = function (n) {
    that.room.webrtc = null;
    that.delToMic(3);
    let dom = document.getElementById('local_video');
    if (that.joined == false) {
      that.localStream = null;
      that.remoteStreams = [];
      if (dom) dom.innerHTML = '';
      return;
    }
    that.client.leave(function () {
      console.log('destroyRoom：', n);
      that.joined = false;
      if (that.localStream) {
        that.localStream.stop();
        that.localStream.close();
        that.localStream = null;
        that.playMusic = null;
      }
      while (that.remoteStreams.length > 0) {
        var stream = that.remoteStreams.shift();
        stream.isPlaying() && stream.stop();
      }
      that.remoteStreams = [];
      //清空一次声网播放器
      if (dom) dom.innerHTML = '';
    });
    //关闭底部菜单操作栏
    that.room.events['CHANGE_MIC_STATE'] &&
      that.room.events['CHANGE_MIC_STATE']('none', that.playVolume);
    //关闭伴奏状态
    that.room.events['CHANGE_AUDIO_STATE'] &&
      that.room.events['CHANGE_AUDIO_STATE'](false);

    store.dispatch({type: "RTC_LOAD_COMPLETE", data: {rtcLoadComplete: false}});
  };
  //设置变声
  that.setAudioEffectPreset = function (value) {
    return new Promise(function (resolve, reject) {
      resolve();
    });
  };
  //设置美声音效
  that.setVoiceBeautifierPreset = function (value) {
    return new Promise(function (resolve, reject) {
      resolve();
    });
  };
  //设置本地语音音调。
  that.setLocalVoicePitch = function (value) {
    return new Promise(function (resolve, reject) {
      resolve();
    });
  };
  //设置本地语音音效均衡。
  that.setLocalVoiceEqualization = function (value) {
    return new Promise(function (resolve, reject) {
      resolve();
    });
  };
  /***
   * 游戏方操作闭麦开麦
   * */
  that.gameOperateRTC = {
    syncGameStatus: (bool = false) => {
      that.isGameing = bool;

      if (!bool) {
        that.isGameOperateMic = false;
        that.isGameOperateSpeaker = false;
      }
    },
    // 开麦
    openMicrophone: () => {
      if (that.client && that.isGameing && that.localStream) {
        that.isGameOperateMic = true;
        that.changeMicState({ open: true, operateSource: true });
      }
    },
    // 闭麦
    closeMicrophone: () => {
      if (that.client && that.isGameing && that.localStream) {
        that.isGameOperateMic = true;
        that.changeMicState({ open: false, operateSource: true });
      }
    },
    // 开启扬声器
    openSpeaker: () => {
      if (that.client && that.isGameing) {
        that.isGameOperateSpeaker = true;
        that.changeVoiceState({ open: true, operateSource: true });
      }
    },
    // 关闭扬声器
    closeSpeaker: () => {
      if (that.client && that.isGameing) {
        that.isGameOperateSpeaker = true;
        that.changeVoiceState({ open: false, operateSource: true });
      }
    },
  };
  return that;
})();
export default ARTC;
